/**
 * Created by lidonghua on 2018/4/9.
 */

import {init} from './init'
const configs = {
    //loading
    COMMONLOADING: {
        type: "COMMONLOADING",
        url: "",
        method: "commonLoading",
        defaultState: {
            show: false,   //页面loading
        }
    },
    //当前待领取权益
    RECEIVEINTEREST: {
        type: "RECEIVEINTEREST",
        url: "",
        method: "receiveInterest",
        defaultState: {
            requested: false,
            list: []
        }
    },
    //当前待领取权益
    UNRECEIVEINTEREST: {
        type: "UNRECEIVEINTEREST",
        url: "",
        method: "unReceiveInterest",
        defaultState: {
            requested: false,
            list: []
        }
    }
}

// init state
export default init(configs);



// WEBPACK FOOTER //
// ./src/store/modules/common.js